import axios from "axios";
import AuthService from "../services/auth.service";

const API_URL =
  process.env.NODE_ENV !== "production"
    ? "https://we-village-api.onrender.com/"
    : "https://we-village-api.onrender.com/";

axios.interceptors.request.use(function (config) {
  const token = AuthService.getCurrentUserTokken();
  config.headers.Authorization = "Bearer " + token;
  config.headers[
    "API-TOKEN"
  ] = `c1462debeb1e53644f768cbbc6a9562b73009-56a1e28ea706dc0bc38ba5ae990`;
  return config;
});
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

const getAllFlexcareBookings = () => {
  return axios.get(API_URL + "api/booking/get");
};

const getAllWinterCampBookings = () => {
  return axios.get(API_URL + "api/camp-bookings");
};

const getAllUsers = () => {
  return axios.get(API_URL + "api/user/getAll");
};

const getSingleUser = (id) => {
  return axios.get(`${API_URL}api/user/get/${id}`);
};

const createUser = (data) => {
  return axios.post(API_URL + "api/user/create", data);
};

const updateUser = (id, data) => {
  return axios.put(`${API_URL}api/user/update/${id}`, data);
};

const deleteUser = (id) => {
  return axios.delete(`${API_URL}api/user/delete/${id}`);
};

const getAllProgramPrices = () => {
  return axios.get(API_URL + "api/program-price/getAll");
};

const updateProgramPrice = (id, data) => {
  return axios.put(`${API_URL}api/program-price/update/${id}`, data);
};

const createProgramPrice = (data) => {
  return axios.post(API_URL + "api/program-price/create", data);
};

const deleteProgramPrice = (id) => {
  return axios.delete(`${API_URL}api/program-price/delete/${id}`);
};
const createInvoice = (data) => {
  return axios.post(API_URL + "api/invoice/create", data);
};
const getAllInvoices = () => {
  return axios.get(API_URL + "api/invoice/getAll");
};
const getSingleInvoice = (id) => {
  return axios.get(`${API_URL}api/invoice/get/${id}`);
};

const deleteInvoice = (id) => {
  return axios.delete(`${API_URL}api/invoice/delete/${id}`);
};

const DataService = {
  getAllFlexcareBookings,
  getAllWinterCampBookings,
  getAllUsers,
  getSingleUser,
  createUser,
  updateUser,
  deleteUser,
  getAllProgramPrices,
  updateProgramPrice,
  createProgramPrice,
  deleteProgramPrice,
  createInvoice,
  getAllInvoices,
  getSingleInvoice,
  deleteInvoice,
};
export default DataService;
